export enum ApolloClientLinksEnum {
    unifiedApi = 'unifiedApi',
    sparkApi = 'sparkApi',
}
